{
  "AGENT_BOTS": {
    "HEADER": "Boti",
    "LOADING_EDITOR": "Nalaganje urejevalnika ...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Sistem",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatar bota je bil uspešno izbrisan",
      "ERROR_DELETE": "Napaka pri brisanju avatarja bota, poskusite znova"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Ime bota",
        "PLACEHOLDER": "Poimenujte svojega bota.",
        "ERROR": "Zahtevano je ime bota."
      },
      "DESCRIPTION": {
        "LABEL": "Opis bota",
        "PLACEHOLDER": "Kaj počne ta bot?"
      },
      "BOT_CONFIG": {
        "ERROR": "Zgoraj vnesite svojo konfiguracijo bota CSML.",
        "API_ERROR": "Vaša konfiguracija CSML je neveljavna. Popravite jo in poskusite znova."
      },
      "SUBMIT": "Preveri in shrani"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Izberite agentskega bota",
      "DESC": "Dodelite Agentskega Bota v svoj nabiralnik. Ti lahko vodijo začetne pogovore in jih po potrebi prenesejo na agenta v živo.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Posodobi",
      "DISCONNECT": "Odklopi bota",
      "SUCCESS_MESSAGE": "Agentski bot je bil uspešno posodobljen.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Povezava z agentskega bota je bila uspešno prekinjena.",
      "ERROR_MESSAGE": "Agentskega bota ni bilo mogoče posodobiti. Prosimo poskusite ponovno.",
      "DISCONNECTED_ERROR_MESSAGE": "Ni bilo mogoče prekiniti povezave z agentskim botom. Prosimo poskusite ponovno.",
      "SELECT_PLACEHOLDER": "Izberi bota",
      "COUNTRY_BOTS": {
        "TITLE": "Boti po državah",
        "DESC": "Ta nabiralnik obsluguje več držav. Pogovor gre k botu svoje države: glede na trgovino Kaufland, glede na tržnico naročila Allegro, sicer glede na jezik, v katerem piše kupec. Vsi drugi pogovori gredo k privzetemu botu zgoraj.",
        "COUNTRY": "Izberite državo",
        "BOT": "Izberite bota",
        "ADD": "Dodaj bota za državo",
        "REMOVE": "Odstrani",
        "DEFAULT_REQUIRED": "Najprej izberite privzetega bota. Bot države ga nadomesti samo za to državo.",
        "DISCONNECT_ALL": "Odklopi vse bote"
      }
    },
    "ADD": {
      "TITLE": "Konfigurirajte novega bota",
      "CANCEL_BUTTON_TEXT": "Prekliči",
      "API": {
        "SUCCESS_MESSAGE": "Bot je bil uspešno dodan.",
        "ERROR_MESSAGE": "Bota ni bilo mogoče dodati. Poskusite znova pozneje."
      }
    },
    "LIST": {
      "404": "Botov ni bilo mogoče najti. Bota lahko ustvarite s klikom na gumb 'Konfigurirajte novega bota' ↗",
      "LOADING": "Pridobivanje botov ...",
      "TABLE_HEADER": {
        "DETAILS": "Podrobnosti bota",
        "URL": "URL webhooka"
      },
      "TYPE": "Vrsta bota"
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "TITLE": "Izbriši bota",
      "CONFIRM": {
        "TITLE": "Potrdite izbris",
        "MESSAGE": "Ali ste prepričani, da želite izbrisati {name}?",
        "YES": "Da, izbriši",
        "NO": "Ne, obdrži"
      },
      "SUBMIT": "Izbriši",
      "CANCEL_BUTTON_TEXT": "Prekliči",
      "DESCRIPTION": "Ali ste prepričani, da želite izbrisati tega bota? To dejanje ni mogoče preklicati.",
      "API": {
        "SUCCESS_MESSAGE": "Bot uspešno izbrisan.",
        "ERROR_MESSAGE": "Bota ni bilo mogoče izbrisati. Prosimo poskusite ponovno."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Uredi",
      "LOADING": "Pridobivanje botov ...",
      "TITLE": "Uredi bota",
      "CANCEL_BUTTON_TEXT": "Prekliči",
      "API": {
        "SUCCESS_MESSAGE": "Bot je bil uspešno posodobljen.",
        "ERROR_MESSAGE": "Bota ni bilo mogoče posodobiti. Prosimo poskusite ponovno."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar bota"
      },
      "NAME": {
        "LABEL": "Ime bota",
        "PLACEHOLDER": "Vnesite ime bota"
      },
      "DESCRIPTION": {
        "LABEL": "Opis",
        "PLACEHOLDER": "Kaj počne ta bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL webhooka",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Ime bota je obvezno",
        "URL": "URL webhooka je obvezen",
        "VALID_URL": "Vnesite veljaven URL, ki se začne s http:// ali https://"
      },
      "CANCEL": "Prekliči",
      "CREATE": "Ustvari bota",
      "UPDATE": "Posodobi bota"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
